<template>
  <el-group-title class="d_jump" title="基本信息">
    <template slot="groupTitle">
      <el-form
        :model="form"
        ref="form"
        label-width="160px"
        class="ccui-form ccui-form-detail"
      >
        <el-col :span="12">
          <el-form-item label="招标结果：" prop="tenderResult">
            <div v-text="form.tenderResult"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="项目：" prop="project">
            <div v-text="form.project"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="合同编号：" prop="contractNumber">
            <div v-text="form.contractNumber"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="合同名称：" prop="contractName">
            <div v-text="form.contractName"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="采购方式：" prop="procurementMethod">
            <div v-text="form.procurementMethod"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="甲方：" prop="owner">
            <div v-text="form.owner"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="乙方：" prop="secondParty">
            <div v-text="form.secondParty"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="项目合同签订人：" prop="signatory">
            <div v-text="form.signatory"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="签订日期：" prop="signing">
            <div v-text="form.signing"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="采购计划总编号：" prop="reinforced">
            <div v-text="form.reinforced"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="招标编号：" prop="reference">
            <div v-text="form.reference"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="编制日期：" prop="compileDate">
            <div v-text="form.compileDate"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="税率：">
            <div v-text="form.taxRate"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="税额：" prop="assessment">
            <div v-text="form.assessment"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="合同总价（含税）：" prop="contract">
            <div v-text="form.contract"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="合同总价（不含税）：" prop="contractAfterTax">
            <div v-text="form.contractAfterTax"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="变更后合同总价（含税）：" prop="combustible">
            <div v-text="form.combustible"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            label="变更后合同总价（不含税）："
            prop="combustibleNo"
            class="ccui-pre-form-item"
          >
            <div v-text="form.combustibleNo"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="是否浮动合同价格：" prop="floating">
            <div v-text="form.floating == '1' ? '是' : '否'"></div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="浮动价说明：" prop="floatingTitle">
            <div v-text="form.floatingTitle"></div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="价格填写方式：">
            <div
              v-text="
                form.responsibility == '01' ? '填写含税价' : '填写不含税价'
              "
            ></div>
          </el-form-item>
        </el-col>

        <el-col :span="18">
          <el-form-item label="合同主要条款：" prop="mainTerms">
            <div v-text="form.mainTerms"></div>
          </el-form-item>
        </el-col>

        <el-col :span="18">
          <el-form-item label="备注：" prop="postscript">
            <div v-text="form.postscript"></div>
          </el-form-item>
        </el-col>
      </el-form>
    </template>
  </el-group-title>
</template>

<script>
export default {
  props: {
    baseInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      // title: "",
      form: {
        tenderResult: "", // 招标结果
        project: "", // 项目
        contractNumber: "", // 合同编号
        contractName: "", // 合同名称
        procurementMethod: "", // 采购方式
        owner: "", // 甲方
        secondParty: "", // 乙方
        signatory: "", // 项目合同签订人
        signing: "", // 签订日期
        taxRate: "", // 税率
        reinforced: "", // 采购计划总编号
        reference: "", // 招标编号
        compileDate: "", // 编制日期
        contract: "", // 合同总价（含税）
        contractAfterTax: "", // 合同总价（不含税）
        assessment: "", // 税额
        combustible: "", // 变更后合同总价（含税）
        floating: "", // 是否浮动合同价格
        customerName: "",
        combustibleNo: "", // 变更后合同总价（不含税）
        floatingTitle: "", // 浮动价说明
        mainTerms: "", // 合同主要条款
        responsibility: "", // 价格填写方式
        postscript: "" // 备注
      },
      tableData: [
        {
          id: "1"
        }
      ]
    };
  },
  watch: {
    baseInfo() {
      this.form = this.baseInfo;
    },
    responsibility() {
      this.$emit("gatResponsibility", this.responsibility);
    },
    taxRate() {
      this.$emit("gatTaxRate", this.taxRate);
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
/deep/ .el-button--single-number {
  width: 46px;
  margin-left: 10px;
  padding: 0 9px;
}
/deep/.ccui-pre-form-item {
  .el-form-item__label {
    line-height: 16px;
  }
}
</style>
